import { render } from "./Login1.vue?vue&type=template&id=23f107f0&scoped=true"
const script = {}

import "./Login1.vue?vue&type=style&index=0&id=23f107f0&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f107f0"]])

export default __exports__